import './loading.css'

interface LoadingProps {
	/**
	 * Text to display below the animation
	 * @default "Loading..."
	 */
	text?: string
	/**
	 * Size variant
	 * @default "default"
	 */
	size?: 'sm' | 'default' | 'lg'
	/**
	 * Whether to show the fullscreen version (centers in viewport)
	 * @default false
	 */
	fullscreen?: boolean
}

/**
 * Unified loading component with engaging animation
 * Replaces all loading spinners across the application
 */
export function Loading({ text = 'Loading...', size = 'default', fullscreen = false }: LoadingProps) {
	return (
		<div className="loading-container" data-fullscreen={fullscreen} data-size={size}>
			<div className="loading-animation">
				{/* Three animated dots suggesting movement/plays in motion */}
				<div className="loading-dot" data-delay="0" />
				<div className="loading-dot" data-delay="1" />
				<div className="loading-dot" data-delay="2" />
			</div>
			{text && <p className="loading-text">{text}</p>}
		</div>
	)
}
